import React, { useState } from 'react';

import { RaceTime as RaceTimeType } from '../../../../types/apiResponses';

import Column from '../../../common/utility/column';
import RaceTime from './raceTime';
import RaceTimePagination from './raceTimePagination';

interface RaceTimeTableProps {
	title: string;
	raceTimes: RaceTimeType[];
}

const maxPerPage = 10;

export default function RaceTimeTable({ title, raceTimes }: RaceTimeTableProps) {
	const [currentPage, setCurrentPage] = useState(1);

	return (
		<Column className="raceTimeTable">
			<h2>{title}</h2>
			<RaceTimePagination
				currentPage={currentPage}
				maxPages={Math.ceil(raceTimes.length / maxPerPage)}
				setCurrentPage={setCurrentPage}
			/>
			<table>
				<thead>
					<tr>
						<th>Race Number</th>
						<th>Name</th>
						<th>Difficulty</th>
						<th>Time</th>
					</tr>
				</thead>
				<tbody>
					{raceTimes
						.slice((currentPage - 1) * maxPerPage, currentPage * maxPerPage)
						.map((raceTime) => {
							const key = `${raceTime.raceNumber}-${raceTime.name}`;
							return <RaceTime raceTime={raceTime} key={key} />;
						})}
				</tbody>
			</table>
		</Column>
	);
}
